export enum UserProfileSoporteKeysEnum {
  USERS_PROFILE_ALL = 'users-profile-all',
}

export enum UsersEnum {
  USERS = 'users',
}
